var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6239 2.19336H7.37835L5.58009 5.45074C5.2244 5.48074 4.87076 5.51139 4.51927 5.54174C3.01631 5.67153 1.77909 6.82952 1.55889 8.32191C1.35941 9.67392 1.17969 11.0663 1.17969 12.4884C1.17969 13.9105 1.35941 15.3029 1.55889 16.6549C1.77909 18.1473 3.01631 19.3053 4.51927 19.4351C6.67566 19.6214 8.83494 19.807 11.0011 19.807C13.1673 19.807 15.3266 19.6214 17.483 19.4351C18.9859 19.3053 20.2231 18.1473 20.4433 16.6549C20.6428 15.3029 20.8225 13.9105 20.8225 12.4884C20.8225 11.0663 20.6428 9.67392 20.4433 8.32192C20.2231 6.82952 18.9859 5.67153 17.483 5.54174C17.1294 5.51119 16.7758 5.48056 16.4221 5.45074L14.6239 2.19336Z",
    fill: "#426306",
    stroke: "#84C70D",
    strokeWidth: 2.35714,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0006 15.5617C12.9533 15.5617 14.5363 13.9787 14.5363 12.0259C14.5363 10.0732 12.9533 8.49023 11.0006 8.49023C9.04784 8.49023 7.46484 10.0732 7.46484 12.0259C7.46484 13.9787 9.04784 15.5617 11.0006 15.5617Z",
    fill: "#426306",
    stroke: "#84C70D",
    strokeWidth: 2.35714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.94c98fbf7d1aa6b3e5140d153ab05df6.svg";
export { ForwardRef as ReactComponent };